import React from 'react';
import { Mail, Phone, Eye, Trash2 } from 'lucide-react';
import { Card, CardContent } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import { Badge } from '../../../components/ui/badge';

export const ClientCard = ({ client, onView, onDelete }) => (
  <Card className="hover:shadow-lg transition-shadow">
    <CardContent className="p-4">
      <div className="flex items-start justify-between mb-3">
        <div>
          <h3 className="font-semibold text-gray-900">{client.company_name}</h3>
          <p className="text-sm text-gray-500">{client.account_number}</p>
        </div>
        <div className="flex flex-col items-end gap-1">
          <Badge className={client.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}>
            {client.status}
          </Badge>
          {client.client_type_name && (
            <Badge
              className={`text-xs ${
                client.has_guaranteed_returns
                  ? 'bg-purple-100 text-purple-800'
                  : client.discount_percent > 15
                    ? 'bg-blue-100 text-blue-800'
                    : 'bg-amber-100 text-amber-800'
              }`}
              data-testid={`pricing-tier-badge-${client.id}`}
            >
              {client.client_type_name}
              {client.discount_percent > 0 && ` (${client.discount_percent}%)`}
            </Badge>
          )}
        </div>
      </div>

      {client.contacts?.[0] && (
        <div className="space-y-1 mb-3 text-sm text-gray-600">
          <div className="flex items-center gap-2">
            <Mail className="h-3 w-3" />
            <span className="truncate">{client.contacts[0].email}</span>
          </div>
          {client.contacts[0].phone && (
            <div className="flex items-center gap-2">
              <Phone className="h-3 w-3" />
              <span>{client.contacts[0].phone}</span>
            </div>
          )}
        </div>
      )}

      <div className="grid grid-cols-2 gap-3 pt-3 border-t">
        <div>
          <p className="text-xs text-gray-500">Orders</p>
          <p className="font-semibold">{client.order_count}</p>
        </div>
        <div>
          <p className="text-xs text-gray-500">Open Balance</p>
          <p className={`font-semibold ${client.open_balance > 0 ? 'text-amber-600' : 'text-gray-900'}`}>
            ${client.open_balance.toFixed(2)}
          </p>
        </div>
      </div>

      <Button variant="outline" className="w-full mt-3" onClick={() => onView(client)}>
        <Eye className="h-4 w-4 mr-2" />
        View & Edit
      </Button>
      <Button
        variant="ghost"
        className="w-full mt-2 text-red-500 hover:text-red-600 hover:bg-red-50"
        onClick={() => onDelete(client)}
      >
        <Trash2 className="h-4 w-4 mr-2" />
        Delete
      </Button>
    </CardContent>
  </Card>
);
